import { MdVerified, MdStar, MdAccessTime, MdPayment } from 'react-icons/md';
import { t } from '../../utils/i18n';

const BADGES = [
  { key: 'verified', icon: MdVerified },
  { key: 'reviews', icon: MdStar },
  { key: 'tracking', icon: MdAccessTime },
  { key: 'payment', icon: MdPayment },
];

export default function TrustBadges({ variant = 'strip' }) {
  if (variant === 'micro') {
    return (
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5 text-xs sm:text-sm text-[var(--color-text-muted)]">
        {BADGES.map(({ key }, i) => (
          <span key={key} className="inline-flex items-center gap-1">
            {i > 0 && <span className="text-[var(--color-border)]" aria-hidden="true">·</span>}
            {t(`landing.trust.${key}`)}
          </span>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap justify-center lg:justify-start gap-2 sm:gap-2.5">
      {BADGES.map(({ key, icon: Icon }) => (
        <div
          key={key}
          className="landing-trust-pill inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs sm:text-sm font-medium transition-colors"
        >
          <Icon className="text-sm flex-shrink-0 text-primary-500 dark:text-primary-400" aria-hidden="true" />
          <span>{t(`landing.trust.${key}`)}</span>
        </div>
      ))}
    </div>
  );
}
